import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {DrugInteractionDTO} from 'src/app/modules/pbm/models/DrugInteractionDTO';
import {PagedRequestDTO} from 'src/app/modules/common/models/PagedRequestDTO';
import {PagedResponseDTO} from 'src/app/modules/common/models/PagedResponseDTO';

@Injectable({
  providedIn: 'root'
})
export class DrugInteractionService {

  private url = environment.baseUrl + '/drug-interaction';

  constructor(private httpClient: HttpClient) {
  }

  getListOfDrugInteractions(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<DrugInteractionDTO>> {
    return this.httpClient.post<PagedResponseDTO<DrugInteractionDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  saveDrugInteraction(drugInteractionDTO: DrugInteractionDTO): Observable<DrugInteractionDTO> {
    return this.httpClient.post<DrugInteractionDTO>(this.url, drugInteractionDTO);
  }

  deleteDrugInteraction(interactionId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.url + '/' + interactionId);
  }

  getDrugInteraction(interactionId: number): Observable<DrugInteractionDTO> {
    return this.httpClient.get<DrugInteractionDTO>(this.url + '/' + interactionId);
  }
}
